import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConferenceViewModel } from 'src/app/_models/generatedModels';
import { OrganizationService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-my-conference-container',
  templateUrl: 'my-conference-container.component.html'
})
export class MyConferenceContainerComponent implements OnInit {
  conferenceId: number;
  conference: ConferenceViewModel;
  initialized = false;
  
  constructor(private route: ActivatedRoute, private organizationService: OrganizationService) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.conferenceId = +params['conferenceId'];

      this.organizationService.getConferenceBySlugBasic(this.conferenceId.toString()).subscribe((result) => {
        this.conference = result;
        this.initialized = true;
      });
    });
  }
}
